export default "__VITE_ASSET__BNjMvdUY__"